enum CalendarType {
  JUDICIAL = 'JUDICIAL',
  CALENDAR = 'CALENDAR'
}

export default CalendarType;
